import React from 'react'
import { Formik } from 'formik'

import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import { InputField } from 'components/InputField'
import { FormsLayout } from 'components/Layout/Forms'
import { DropDownItem } from 'types/components'

import { AddCorporateContactsFetchParamsSchemasYup } from 'schemas/corporateContactsSchemas'
import { useAddCorporateContact } from './useAddCorporateContact'

const TITLE_OPTIONS: DropDownItem[] = [
    { label: 'Mr', value: '1' },
    { label: 'Mrs', value: '2' },
    { label: 'Ms', value: '3' },
    { label: 'Others', value: '4' },
]

const Index: React.FC<{ onCloseModal: () => void }> = ({
    onCloseModal,
}): React.ReactElement => {
    const { initialValues, isLoading, handleSubmitAddCorporateContact } =
        useAddCorporateContact(onCloseModal)

    if (isLoading) return <></>

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={AddCorporateContactsFetchParamsSchemasYup}
            onSubmit={handleSubmitAddCorporateContact}
        >
            {({ values, setFieldValue, handleSubmit }) => {
                const selectedTitle =
                    TITLE_OPTIONS.find(
                        (option) => Number(option.value) === Number(values.titleId ?? 1)
                    ) ?? null

                return (
                    <FormsLayout.Wrapper onSubmit={handleSubmit}>
                        <FormsLayout.Item>
                            <Dropdown
                                title="Title"
                                value={selectedTitle}
                                options={TITLE_OPTIONS}
                                onSelect={(item: DropDownItem) =>
                                    setFieldValue('titleId', Number(item.value))
                                }
                                className="w-full tracking-wider"
                                containerClassName="w-full"
                                borderColor="#C4C4C4"
                            />
                        </FormsLayout.Item>
                        <div className="flex gap-4">
                            <FormsLayout.Item>
                                <InputField
                                    type="input"
                                    name="firstName"
                                    label="First Name"
                                    value={values.firstName}
                                    onChange={(e) => setFieldValue('firstName', e.target.value)}
                                    containerClassName="flex flex-col flex-grow"
                                    rounded
                                />
                            </FormsLayout.Item>

                            <FormsLayout.Item>
                                <InputField
                                    type="input"
                                    name="middleNames"
                                    label="Middle Name"
                                    value={values.middleNames}
                                    onChange={(e) => setFieldValue('middleNames', e.target.value)}
                                    containerClassName="flex flex-col flex-grow"
                                    rounded
                                />
                            </FormsLayout.Item>

                            <FormsLayout.Item>
                                <InputField
                                    type="input"
                                    name="lastName"
                                    label="Last Name"
                                    value={values.lastName}
                                    onChange={(e) => setFieldValue('lastName', e.target.value)}
                                    containerClassName="flex flex-col flex-grow"
                                    rounded
                                />
                            </FormsLayout.Item>
                        </div>

                        <div className="flex gap-4">
                            <FormsLayout.Item>
                                <InputField
                                    type="input"
                                    name="phone1"
                                    label="Work Phone"
                                    value={values.phone1}
                                    onChange={(e) => setFieldValue('phone1', e.target.value)}
                                    containerClassName="flex flex-col flex-grow"
                                    rounded
                                />
                            </FormsLayout.Item>

                            <FormsLayout.Item>
                                <InputField
                                    type="input"
                                    name="mobile"
                                    label="Mobile Number"
                                    value={values.mobile}
                                    onChange={(e) => setFieldValue('mobile', e.target.value)}
                                    containerClassName="flex flex-col flex-grow"
                                    rounded
                                />
                            </FormsLayout.Item>

                            <FormsLayout.Item>
                                <InputField
                                    type="input"
                                    name="email"
                                    label="Email"
                                    value={values.email}
                                    onChange={(e) => setFieldValue('email', e.target.value)}
                                    containerClassName="flex flex-col flex-grow"
                                    rounded
                                />
                            </FormsLayout.Item>
                        </div>

                        <FormsLayout.Item>
                            <InputField
                                type="input"
                                name="comments"
                                label="Comments"
                                value={values.comments}
                                onChange={(e) => setFieldValue('comments', e.target.value)}
                                containerClassName="flex flex-col flex-grow"
                                rounded
                            />
                        </FormsLayout.Item>

                        <div className="flex gap-4">
                            <FormsLayout.Item>
                                <label className="flex items-center gap-2 text-sm tracking-wider font-light text-gray-700 h-full">
                                    <input
                                        type="checkbox"
                                        checked={Boolean(values.isPrimary)}
                                        onChange={(e) => setFieldValue('isPrimary', e.target.checked)}
                                    />
                                    <span>Primary</span>
                                </label>
                            </FormsLayout.Item>

                            <FormsLayout.Item>
                                <label className="flex items-center gap-2 text-sm tracking-wider font-light text-gray-700 h-full">
                                    <input
                                        type="checkbox"
                                        checked={Boolean(values.isActive)}
                                        onChange={(e) => setFieldValue('isActive', e.target.checked)}
                                    />
                                    <span>Active</span>
                                </label>
                            </FormsLayout.Item>
                        </div>

                        <FormsLayout.ActionWrapper>
                            <Button key="submit" type="submit" className="rounded bg-primary tracking-wider font-bold">
                                Add
                            </Button>
                        </FormsLayout.ActionWrapper>
                    </FormsLayout.Wrapper>
                )
            }}
        </Formik>
    )
}

export default Index
